/**
 * The appointment confirmation page's API calls. Like services/portal.js this
 * is plain fetch, not the app's axios client: the client has no account, so no
 * session token is sent and a 404 must not open the sign-in dialog — it only
 * means the link is no longer valid.
 */
export class ConfirmLinkError extends Error {}

// A 400/409 on POST carries a machine-readable `detail` the page maps to copy.
export class ConfirmRejectedError extends Error {
  constructor(detail) {
    super(detail);
    this.detail = detail;
  }
}

const url = (token) => `/api/confirm/${encodeURIComponent(token)}`;

async function parse(response) {
  if (response.status === 404) throw new ConfirmLinkError('invalid_link');
  if (!response.ok) {
    let detail = '';
    try { detail = (await response.json()).detail; } catch (e) { /* not JSON */ }
    if (response.status === 400 || response.status === 409) throw new ConfirmRejectedError(detail);
    throw new Error(`confirm_${response.status}`);
  }
  return response.json();
}

export async function fetchConfirmation(token) {
  return parse(await fetch(url(token), {
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  }));
}

export async function submitConfirmation(token, acceptTerms) {
  return parse(await fetch(url(token), {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ accept_terms: !!acceptTerms }),
  }));
}
